/**
 * Category (kategoriya) Zod schemalar — TOLIQ_QOLLANMA sec 9
 */
import { z } from 'zod';
import { uuidSchema } from './common.schema.js';
// ─── Name / markup umumiy ─────────────────────────────────────────
const nameSchema = z
    .string()
    .trim()
    .min(1, 'Kategoriya nomi kerak')
    .max(100, 'Nom 100 belgidan oshmasligi kerak');
const markupSchema = z
    .number()
    .min(0, "Foiz manfiy bo'lmaydi")
    .max(1000, 'Foiz 1000 dan oshmasligi kerak');
// Marketplace fon id (fonchi background fayl nomi) — bo'sh = biriktirilmagan
const marketplaceBackgroundSchema = z
    .string()
    .trim()
    .max(160)
    .regex(/^[a-zA-Z0-9_-]+$/, "Fon id faqat harf/raqam/-/_ bo'lishi mumkin");
// ─── Create ───────────────────────────────────────────────────────
export const createCategorySchema = z.object({
    name: nameSchema,
    parentId: uuidSchema.nullable().optional(),
    markupPercent: markupSchema.default(25),
    marketplaceBackground: marketplaceBackgroundSchema.nullable().optional(),
});
// ─── Update (partial) ─────────────────────────────────────────────
export const updateCategorySchema = z.object({
    name: nameSchema.optional(),
    markupPercent: markupSchema.optional(),
    marketplaceBackground: marketplaceBackgroundSchema.nullable().optional(),
});
// ─── Recalculate prices (dialog confirmation payload) ─────────────
export const recalculateCategoryPricesSchema = z.object({
    confirm: z.literal(true, { errorMap: () => ({ message: 'Tasdiq kerak' }) }),
});
//# sourceMappingURL=category.schema.js.map